import React from "react";
import {useSelector} from "react-redux";
import {getDetailData} from "../../models/loginModel";
import Detail from "../common/detail/Detail";

const ProfileDetail = () => {
    const {
        user,
        selectedRole: userRole,
    } = useSelector((state) => state.auth);

    const detailData = getDetailData({ item:user,userRole });
    return (
       <>
           <Detail inline={true} columns={{ lg: 9, xl: 7 }} data={detailData} />
       </>
    );
}
export default ProfileDetail;
